import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  @media (max-width: 900px) and (min-width: 550px) and (max-height: 575px) {
    padding-top: 50px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  background-color: ${({ theme }) => theme.background};

  @media (min-width: 996px) {
    > p {
      display: none;
    }
  }

  @media (max-width: 996px) {
    margin-top: 2rem;
    width: 100vw;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      color: #fff;
      margin-top: auto;

      svg {
        margin-left: 8px;
        transform: rotateX(180deg);
      }
    }
  }
`;

export const GameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: calc(100% - 21vw);

  @media (min-width: 996px) {
    &::before {
      content: '';
      width: 100%;
      height: 1.25rem;
      background: #9fa7f7;
    }
  }

  @media (max-width: 996px) {
    margin-top: 1rem;
  }

  > div {
    display: flex;
    width: 100%;
  }
`;
